module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAADKADAAQAAAABAAAACQAAAADb7HUtAAAAqUlEQVQYGWPk9pjgzsDwV5SJgfErAx7wj+E/NwMj4ysWBsb/Ioz/Gf+ws/HvebMp+TM2PSJ+c3l//Pro/Z+BUZSJ6f//bxxs/FtBAiAJdA0wxZy87FtAaplACkAmY9OErPj16uwvILVgDdg0YVOMogFdE8iJIGfATAbJgwDcBggX4jxu0b+bQRhdMUgNC0whMv1ycSnOIGbk85hg+p/hnwyyBlxsJiaGxwBvy2DuidDA5wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/email.png
// module id = m6Hc
// module chunks = 1